import { alpha, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DivBlockStyled = styled('div')({
  border: '1px solid #ccc',
  width: 40,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 4,
  '&:hover': {
    backgroundColor: alpha('#ccc', 0.4),
    cursor: 'pointer',
  },
});

export const DivSearchStyled = styled('div')({
  backgroundColor: '#212334',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 450,
  maxHeight: 42,
  padding: '0 16px',
  borderRadius: 2,
  color: '#ccc',
  '& input': {
    color: '#ccc',
    '&::placeholder': {
      color: '#ccc',
    },
  },
});

export const CellHeaderStyled = styled(TableHead)({
  backgroundColor: '#0A1123',
  '& th': {
    color: '#FFF',
    fontWeight: 500,
    border: 'none',
  },
});

export const CellStyled = styled(TableRow)({
  backgroundColor: alpha('#192033', 0.9),
  color: '#999',
  border: 'none',
  cursor: 'pointer',
  '&:nth-of-type(odd)': {
    backgroundColor: '#171D2D',
    color: 'lightgray',
  },
  '& td': {
    color: 'lightgray',
    border: 'none',
    '& > input': {
      backgroundColor: 'red',
    },
  },
  '& .date1': {
    color: '#8BC86F',
  },
  '& .date2': {
    color: '#FF8B9A',
  },
});
